import React, { useEffect, useState } from 'react';
import { assertFunction } from '@Utils/assert';
import ProfileSettings from '@Services/ProfileSettings';

export const withCombinedInfoDisplayName = 'withCombinedInfo';

export function withCombinedInfo({ loaded } = {}) {
  assertFunction(loaded, 'loaded');

  return (WrappedComponent) => {
    function WithCombinedInfo(props) {
      const [isMounted, setIsMounted] = useState(false);

      useEffect(() => {
        const loadCombinedInfo = async () => {
          const combinedInfo = await ProfileSettings.loadCombineInfo();
          if (isMounted) {
            loaded(props, combinedInfo);
          }
        };

        setIsMounted(true);
        loadCombinedInfo();

        return () => {
          setIsMounted(false);
        };
      }, [isMounted, props]);

      return <WrappedComponent {...props} />;
    }

    return WithCombinedInfo;
  };
}
